import { type Node } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import type { Node_Type } from 'ricos-schema';
import { getListSymbol, normalizeOffset } from 'wix-rich-content-common';

import { getListItemsWithVisibleIndentation } from '../list-item/commands/commons';

/**
 * This decoration plugin adds inline styling and aria-level attribute
 * to list items based on their nesting level and parents' offset sum.
 */
export const createIndentationStylingDecorationPlugin = () => {
  return new Plugin({
    key: new PluginKey(`indentation-styling`),
    props: {
      decorations: ({ tr }) => {
        const decorations: Decoration[] = [];

        const listItemsWithVisualIndent = getListItemsWithVisibleIndentation(tr);

        listItemsWithVisualIndent.forEach(({ node, pos, visibleIndentation }) => {
          const normalizedVisualIndent = normalizeOffset(visibleIndentation);
          const marker = getListSymbol(normalizedVisualIndent, node.type.name as Node_Type);

          const marginStart = `margin-inline-start: ${
            normalizeOffset(node.attrs.offset || 0) * 2 + 1.5
          }em`;

          node.forEach((childNode: Node, childPos: number) => {
            const childPosInDoc = childPos + pos + 1;
            decorations.push(
              Decoration.node(childPosInDoc, childPosInDoc + childNode.nodeSize, {
                style: `list-style-type: ${marker}; ${marginStart};`,
                'aria-level': `${normalizedVisualIndent + 1}`,
              })
            );
          });
        });
        return DecorationSet.create(tr.doc, decorations);
      },
    },
  });
};
